document.addEventListener("DOMContentLoaded", languageSelectorHandler);

function languageSelectorHandler() {
  const selectorRefs = {
    header: document.querySelector("header"),
    navButtons: document.querySelectorAll("header .dropdown-toggle"),
    navMenus: document.querySelectorAll("header .showing"),
    navHelpMenu: document.querySelector("header .dropdown-toggle__menu"),
    button: document.querySelector("#header__language--selector button"),
    buttonMarker: document.querySelector(
      "#header__language--selector button .header-arrow"
    ),
    content: document.querySelector(
      "#header__language--selector .language--selector__content"
    ),
    items: document.querySelectorAll("#header__language--selector li"),
    mobileSelector: document.querySelector(
      "#language--selector__mobile .language--selector__content "
    ),
    mobileButton: document.querySelector("#language--selector__mobile button"),
  };

  selectorRefs.mobileButton.addEventListener("click", event => {
    // const arrow = event.currentTarget.querySelector(".header-arrow");
    // event.currentTarget.classList.toggle("active");
    // arrow.classList.toggle("rotate180");
    // selectorRefs.mobileSelector.classList.toggle("open");
    $('body').addClass('popup-open');
    $('.lp_outer[data-popup="change"]').css('display', 'flex');
    setTimeout(function(){
        $('.lp_outer').addClass('visible');
    }, 500);
  });

  function onLanguageSelectorClick(event) {
    event.stopPropagation();
    // selectorRefs.content.classList.toggle("open");
    // selectorRefs.buttonMarker.classList.toggle("rotate180");
    // selectorRefs.navMenus.forEach(menu => {
    //   menu.classList.remove("showing");
    // });
    // selectorRefs.navHelpMenu.classList.remove("active");

    // if (selectorRefs.content.classList.contains("open")) {
    //   selectorRefs.header.classList.add("menu-showing");
    // } else {
    //   selectorRefs.header.classList.remove("menu-showing");
    // }

    // selectorRefs.navButtons.forEach(btn => {
    //   btn.classList.remove("dropdown-showed");
    // });

    // const showingElem = document.querySelector(".drop-down-overlay.showing");
    // if (showingElem) {
    //   showingElem.classList.remove("showing");
    //   showingElem.style.display = "none";
    // }
    $('body').addClass('popup-open');
    $('.lp_outer[data-popup="change"]').css('display', 'flex');
    setTimeout(function(){
        $('.lp_outer').addClass('visible');
    }, 500);
  }

  document.addEventListener("click", event => {
    const isOpen = selectorRefs.content.classList.contains("open");

    if (isOpen) {
      if (
        event.target !== selectorRefs.content &&
        event.target !== selectorRefs.button
      ) {
        selectorRefs.content.classList.remove("open");
        selectorRefs.buttonMarker.classList.remove("rotate180");
      }
    }
  });

  selectorRefs.button.addEventListener("click", onLanguageSelectorClick);

  /*
  selectorRefs.items.forEach(item => {
    const { marker } = item.dataset;

    item.addEventListener("click", () => {
      const url = window.canonicalURL;
      const newDomain = `desktronic.${marker}`;
      const newUrl = url.replace(/(https:\/\/)[^\/]+/, `$1${newDomain}`);

      // window.location.href = newUrl;
      window.location.href = `https://desktronic.${marker}`;
    });
  });
  */
}
